module.exports = __webpack_public_path__ + "img/98.ea2bca23.jpg";